import { emailAddressValidator } from "../../validators/email-validator";
import { ValidationErrorKey } from "../../validators/general-validation.";

import {
  FormFieldInput,
  HtmlInputMode,
  HtmlInputType,
  InputAutoCompleteAttribute,
  InputFormFieldInit,
} from "./base";

export class FormFieldInputEmail extends FormFieldInput {
  constructor(init: InputFormFieldInit<FormFieldInputEmail>) {
    super({
      ...init,
      label: init.label ?? $localize`E-Mail`,
      placeholder: init.placeholder ?? "emma.muster@example.com",
    });

    this.inputType = HtmlInputType.EMAIL;
    this.validators = [emailAddressValidator, ...(init.validators ?? [])];
    this.autoComplete = InputAutoCompleteAttribute.EMAIL;
    this.inputMode = HtmlInputMode.EMAIL;

    super.addErrorMessages({
      [ValidationErrorKey.EMAIL]: $localize`Bitte geben Sie eine gültige E-Mail-Adresse an.`,
    });
  }
}
